<ng-container *ngIf="loading">
    <app-loader></app-loader>
</ng-container>

<app-abstract-dialog class="confirmation-dialog"
                     *ngIf="!loading"
                     [dialogWidth]="'800'">
    <ng-container abstract-header>
        <mat-icon class="abstract-dialog__header__icon material-icons-round {{dialogData.iconColor}}">
            {{dialogData.icon}}
        </mat-icon>
        <h3 class="abstract-dialog__header__title">{{dialogData.title}}</h3>
    </ng-container>

    <ng-container abstract-content>
        <p class="abstract-dialog__content__text" [innerHTML]="dialogData.message"></p>
    </ng-container>

    <ng-container abstract-footer>
        <div class="abstract-dialog__footer__buttons-wrapper">
            <div class="abstract-dialog__footer__buttons-wrapper__btn-box">
                <app-button
                        [cssClasses]="'small outlined outlined__gray-07'"
                        (buttonClicked)="noEvent.emit()">
                    {{dialogData.noButtonText}}
                </app-button>
            </div>
            <div class="abstract-dialog__footer__buttons-wrapper__btn-box">
                <app-button
                        [cssClasses]="'small solid__blue-07'"
                        (buttonClicked)="yesEvent.emit()">
                    {{dialogData.yesButtonText}}
                </app-button>
            </div>
        </div>
    </ng-container>
</app-abstract-dialog>
